import apiClient from './api'

export default {
  // Get all mail priorities with pagination
  async getMailPriorities(params = {}) {
    try {
      params['_no_pagination_'] = 1
      const response = await apiClient.get('/admin/mail-priorities', { params })
      return response.data
    } catch (error) {
      console.error('Error fetching mail priorities:', error)
      throw error
    }
  },

  // Create a new mail priority
  async createMailPriority(data) {
    try {
      const response = await apiClient.post('/admin/mail-priorities', data)
      return response.data
    } catch (error) {
      console.error('Error creating mail priority:', error)
      throw error
    }
  },

  // Update a mail priority
  async updateMailPriority(id, data) {
    try {
      const response = await apiClient.put(`/admin/mail-priorities/${id}`, data)
      return response.data
    } catch (error) {
      console.error('Error updating mail priority:', error)
      throw error
    }
  },

  // Delete a mail priority
  async deleteMailPriority(id) {
    try {
      const response = await apiClient.delete(`/admin/mail-priorities/${id}`)
      return response.data
    } catch (error) {
      console.error('Error deleting mail priority:', error)
      throw error
    }
  }
} 